import { configAxios, getAxiosConfig } from './apiConfig';
import { createLog } from './logService';

export const checkClient = async (document, email) => {
  try {
    const response = await configAxios.get(`users/check/${document}/${email}`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const fetchCurrentUser = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);
    const response = await config.get(`users/me`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const fetchAvailableTimezones = async () => {
  try {
    const response = await configAxios.get(`users/timezones`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};
